import React from 'react';
import { useSelector } from 'react-redux';
import searchSuggestions from '../../../../../../../config/suggestions_search.json';

function TopSearchSuggestions({ city }) {
  const { userLanguage } = useSelector((state) => state.env) || {};
  const lang = userLanguage || 'en';

  if (!searchSuggestions[city]) {
    return null;
  }

  const suggestions = searchSuggestions[city];
  return (
    <section className="suggestions-row">
      {suggestions.map((suggestion, index) => (
        <a key={index} className="suggestion" href={`https://www.thestorefront.com${lang === 'en' ? '' : `/${lang}`}${suggestion.searchUrl}`} target="_self" style={{ backgroundImage: `url(${suggestion.imageUrl})` }}>
          <div className="gradient-overlay" />
          <div className="content">
            <h3>{suggestion.coreMarketName}</h3>
            <h6>{suggestion.projectType}</h6>
          </div>
        </a>
      ))}
    </section>
  );
}

export default TopSearchSuggestions;
